import { render, staticRenderFns } from "./contact-import-join.vue?vue&type=template&id=24dcb4ef&scoped=true&"
import script from "./contact-import-join.vue?vue&type=script&lang=js&"
export * from "./contact-import-join.vue?vue&type=script&lang=js&"
import style0 from "./contact-import-join.vue?vue&type=style&index=0&id=24dcb4ef&prod&lang=scss&"
import style1 from "./contact-import-join.vue?vue&type=style&index=1&id=24dcb4ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcb4ef",
  null
  
)

export default component.exports